import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-content',
  standalone: true,
  templateUrl: './card-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-content.component.css',
})
export class CardContentComponent {}
